import { render, staticRenderFns } from "./DatabasePage.vue?vue&type=template&id=69af7cbc&"
import script from "./DatabasePage.vue?vue&type=script&lang=js&"
export * from "./DatabasePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports